import { Box } from '@wix/design-system';
import React from 'react';
import heroCardStyles from '../HeroCard/HeroCard.css';
import { BrokerDescription } from './BrokerDescription';
import { BrokerDomainTitle } from './BrokerDomainTitle';
import { BrokerFeePrice } from './BrokerFeePrice';
import { BrokerTakenBadge } from './BrokerTakenBadge';
import { HireBrokerButton } from './HireBrokerButton';
import { SearchedDomainBrokerDataHooks } from './dataHooks';
export const BrokerCardMobile = _ref => {
  let domainName = _ref.domainName;
  return /*#__PURE__*/React.createElement(Box, {
    className: heroCardStyles.card,
    borderRadius: "12px",
    padding: "20px 16px",
    direction: "vertical",
    gap: "16px",
    dataHook: SearchedDomainBrokerDataHooks.component
  }, /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    gap: "16px"
  }, /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    gap: "12px"
  }, /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(BrokerTakenBadge, null)), /*#__PURE__*/React.createElement(BrokerDomainTitle, {
    domainName: domainName
  })), /*#__PURE__*/React.createElement(BrokerDescription, {
    domainName: domainName
  })), /*#__PURE__*/React.createElement(Box, {
    verticalAlign: "bottom",
    align: "space-between",
    gap: "SP3"
  }, /*#__PURE__*/React.createElement(BrokerFeePrice, {
    align: "left"
  }), /*#__PURE__*/React.createElement(HireBrokerButton, {
    domainName: domainName
  })));
};
//# sourceMappingURL=BrokerCardMobile.js.map